import ESSSMIPServiceDetail from "./ESSSMIPServiceDetail";

export default ESSSMIPServiceDetail;
